import { useMemo } from 'react';

const INDEX_STORAGE_KEY = '__currencyIndex';

function createCurrencyIndex(currencies) {
    return currencies.reduce((map, currency, pos) => {
        return Object.assign(map, { [currency.code]: pos });
    }, {});
}

function getCurrency(currencies, code) {
    if (!currencies[INDEX_STORAGE_KEY]) {
        Object.defineProperty(currencies, INDEX_STORAGE_KEY, {
            value: createCurrencyIndex(currencies),
            writable: false,
            enumerable: false,
            configurable: false,
        });
    }
    const pos = currencies[INDEX_STORAGE_KEY][code];
    if (typeof pos === 'number') {
        return { ...currencies[pos] };
    }
}

export default function useCurrency(shop) {
    return useMemo(() => {
        const currency = getCurrency(shop.currencies, shop.settings.currency);
        return currency || {
            code: 'USD',
            name: 'US Dollar',
            symbol: '$',
            rounding: 0,
            namePlural: 'US dollars',
            symbolNative: '$',
            decimalDigits: 2,
        };
    }, [shop.currencies, shop.settings.currency]);
}
